export default __webpack_public_path__ + "static/media/weight_female@2x.bfa84b8b.png";